import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@material-ui/core/TextField";
import { Calendar } from "primereact/calendar";
import { alertActions, FeedbackRptActions } from "../../actions/index.js";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { de } from "date-fns/locale";

class ComperihensiveRep extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: "",
      datalist: [],
      editVisible: false,
      editRow: null,
      id: "",
      statusValue: "",
      statusRemarks: "",
      selectedTrade: null,
      selectedDistrictObj: null,
      selectedPinCode: "",
      districtList: [],
      agentList: [], // ✅ ADD THIS
      selectedAgent: null,
      statusOptions: [],
      statusFilter: "All",
      confirmRejectVisible: false,
    };
  }

handleExport = () => {
  const exportReq = {
    ...this.tblResponse,
    PageSize: -1,
    PageNo: 1,
    First: 1,
  };

  exportReq.FromDate = null

  exportReq.ToDate =null;
  this.props.exportingData(exportReq)
    .then((response) => {
      if (response && response.ResponseCode === "200") {
        const data = response.ResponseData || [];

        if (!data.length) {
          this.toast.show({
            severity: "info",
            summary: "No Data",
            detail: "No records found for the selected filters.",
            life: 3000,
          });
          return;
        }

        const cleaned = this.removeImageColumn(data);
        this.downloadCsvFile(cleaned, "Service request.csv");
      } else {
        this.toast.show({
          severity: "error",
          summary: "Export Failed",
          detail: "No response from server.",
          life: 3000,
        });
      }
    })
    .catch(() => {
      this.toast.show({
        severity: "error",
        summary: "Export Failed",
        detail: "Something went wrong.",
        life: 3000,
      });
    });
};
  getTradeOptions = () => {
    return this.props.ServiceAgentList.map((item) => ({
      label: item.TradeName,
      value: item,
    }));
  };
  onStatusChange = (e) => {
    const status = e.value;

    sessionStorage.setItem("filterStatus", status);
    this.setState({ statusFilter: status });

    if (status === "All") {
      this.tblResponse.SearchValue = ""; // ✅ fetch ALL
    } else {
      this.tblResponse.SearchValue = status;
    }

    this.tblResponse.First = 1; // reset pagination
    this.props.fetchApi(this.tblResponse);
  };

  componentDidMount() {
    debugger;
    this.props.getServiceAgentList();
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toLocaleDateString();
    this.tblResponse.ToDate = new Date().toLocaleDateString();
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    const savedStatus = sessionStorage.getItem("filterStatus");

    if (savedStatus) {
      this.setState({ statusFilter: savedStatus });

      if (savedStatus === "All") {
        this.tblResponse.SearchValue = "";
      } else {
        this.tblResponse.SearchValue = savedStatus;
      }
    }
    
    // ✅ FETCH ALL DATA ON LOAD
    this.props.fetchApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ServiceAgentList !== this.props.ServiceAgentList) {
    }
    if (prevProps.FeedbackList !== this.props.FeedbackList) {
      if (this.props.FeedbackList) {
        var e = this.props.FeedbackList;
        this.setState({
          totalRecords: e[0].TotalRows,
        });
      }
    }
  }
  onTradeChange = (e) => {
    const trade = e.value;

    this.setState({
      selectedTrade: trade,
      districtList: trade.Districts || [],
      agentList: trade ? [trade] : [], // ✅ IMPORTANT
      selectedAgent: trade?.ContactPersonName || null,
      selectedDistrictObj: null,
      selectedPinCode: "",
    });
  };
  onDistrictChange = (e) => {
    this.setState({
      selectedDistrictObj: e.value,
      selectedPinCode: e.value.PinCode,
    });
  };

  onAgentChange = (e) => {
    this.setState({ selectedAgent: e.value });
  };

  handleImageClick(imageUrl) {
    window.open(imageUrl, "_blank");
  }

  photoBodyTemplate = (rowData) => {
    if (rowData.image) {
      return (
        <img
          src={rowData.image}
          alt="Image"
          style={{ cursor: "pointer", width: "50px" }}
          onClick={() => this.handleImageClick(rowData.image)}
        />
      );
    }
    return null;
  };
  photoBodyTemplate1 = (rowData) => {
    if (rowData.warrantyimage) {
      return (
        <img
          src={rowData.warrantyimage}
          alt="Image"
          style={{ cursor: "pointer", width: "50px" }}
          onClick={() => this.handleImageClick(rowData.warrantyimage)}
        />
      );
    }
    return null;
  };
  photoBodyTemplate2 = (rowData) => {
    if (rowData.invoice) {
      return (
        <img
          src={rowData.invoice}
          alt="Image"
          style={{ cursor: "pointer", width: "50px" }}
          onClick={() => this.handleImageClick(rowData.invoice)}
        />
      );
    }
    return null;
  };

  addressBodyTemplate = (rowData) => {
    const address = rowData.Address || "";
    return (
      <div 
        title={address}
        style={{ 
          cursor: "pointer", 
          maxWidth: "200px", 
          overflow: "hidden", 
          textOverflow: "ellipsis", 
          whiteSpace: "nowrap" 
        }}
      >
        {address}
      </div>
    );
  };

  GetFeedback() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);

    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);

    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
  }

  FilterData() {
    this.tblResponse.FromDate = this.state.FromDate;
    this.tblResponse.ToDate = this.state.ToDate;

    this.props.fetchApi(this.tblResponse);
  }

  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();

    dt = yyyy + "/" + mm + "/" + dd;
    return dt;
  }

  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select from date.",
            life: 3000,
          });
          // this.refs.Messchild.showError("Please select from date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          // this.refs.Messchild.showError("Please enter only date.");
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            // this.refs.Messchild.showError("From date must be less than to date.");
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "From date must be less than to date.",
              life: 3000,
            });
            return;
          }
        }

        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select to date.",
            life: 3000,
          });
          // this.refs.Messchild.showError("Please select to date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          // this.refs.Messchild.showError("Please enter only date.");
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "To date must be greater than from date.",
              life: 3000,
            });
            // this.refs.Messchild.showError("To date must be greater than from date.");
            return;
          }
        }

        break;
      default:
        break;
    }

    this.setState({ [name]: value });
  }
  //to lazy load
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate;
    this.tblResponse.ToDate = this.state.ToDate;
  }

  onPage(event) {
    this.props.loadingData(true);

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  //to search
  searchFilter(e) {
    // this.setState({
    //     loading: true
    // });
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  removeImageColumn = (data) => {
    return data.map((item) => {
      const { image, warrantyimage, invoice, ...rest } = item;
      return rest;
    });
  };

  escapeCsvValue = (value) => {
    if (value === null || value === undefined) return "";
    const stringValue = String(value).replace(/"/g, '""');
    return /[",\r\n]/.test(stringValue) ? `"${stringValue}"` : stringValue;
  };

  downloadCsvFile = (rows, fileName) => {
    if (!rows || !rows.length) {
      return;
    }

    const headers = Object.keys(rows[0]);
    const csvRows = [
      headers.join(","),
      ...rows.map((row) =>
        headers.map((header) => this.escapeCsvValue(row[header])).join(",")
      ),
    ];

    const csvContent = "\uFEFF" + csvRows.join("\r\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDt"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
  }

  openEditPopup = (row) => {
    let options = [];

    if (row.Status === "Open") {
      options = [
        { label: "Open", value: "Open" },
        { label: "Assign", value: "Assign" }
      ];
    } else if (row.Status === "Assign") {
      options = [
        { label: "Assign", value: "Assign" },
        { label: "Close", value: "Close" },
      ];
    }

    this.setState({
      editRow: row,
      statusValue: row.Status || "",
      statusRemarks: row.Remarks || "",
      id: row.Id || 0,
      statusOptions: options, 
      editVisible: true,
    });
  };
  formatDate = (rowData, field) => {
    if (!rowData[field]) return "";
    const date = new Date(rowData[field]);
    return date.toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };
  actionTemplate = (rowData) => {
    const isClosed =
      rowData.Status === "Close" ||
      rowData.Status === "Closed" ||
      this.isRejectStatus(rowData.Status);
    if (rowData.Status === "Close" || rowData.Status === "Closed") {
      return (
        <span
          style={{
            color: "#d66c6c",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Closed
        </span>
      );
    }
    if (this.isRejectStatus(rowData.Status)) {
      return (
        <span
          style={{
            color: "#d66c6c",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Rejected
        </span>
      );
    }

    return (
      <button
        className="btn btn-primary btn-sm"
        disabled={isClosed}
        onClick={(e) => {
          e.stopPropagation();
          this.openEditPopup(rowData);
        }}
        title={isClosed ? "Request already closed" : "Close request"}
      >
        Action
      </button>
    );
  };

  rejectionTemplate = (rowData) => {
    if (rowData.Status === "Close" || rowData.Status === "Closed") {
      return (
        <span
          style={{
            color: "#d66c6c",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Closed
        </span>
      );
    }
    if (this.isRejectStatus(rowData.Status)) {
      return (
        <span
          style={{
            color: "#d66c6c",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Rejected
        </span>
      );
    }

    return (
      <button
        className="btn btn-danger btn-sm"
        onClick={(e) => {
          e.stopPropagation();
          this.setState({
            editRow: rowData,
            statusValue: "Reject",
            statusRemarks: "",
            id: rowData.Id || 0,
            confirmRejectVisible: true,
            editVisible: false,
          });
        }}
        title="Reject request"
      >
        Reject
      </button>
    );
  };

  isRejectStatus = (status) => {
    return (status || "").toLowerCase().includes("reject");
  };

  submitClosureRequest = (force = false) => { debugger;
    if (!this.state.statusValue) {
      this.toast.show({
        severity: "error",
        summary: "Error",
        detail: "Please select status",
        life: 3000,
      });
      return;
    }

    const payload = {
      VerificationId: this.state.editRow.VerificationId,
      MobileNo: this.state.editRow.MobileNo,
      Status: this.state.statusValue,
      StatusRemarks: this.state.statusRemarks,
      Id: this.state.id,
      agentList: this.state.agentList,
    };

    if (!force && this.isRejectStatus(this.state.statusValue)) {
      this.setState({ confirmRejectVisible: true, editVisible: false });
      return;
    }

    // Hide popup immediately on submit
    this.setState({ editVisible: false, confirmRejectVisible: false });

    const requestFn = this.isRejectStatus(this.state.statusValue)
      ? this.props.rejectionRequest
      : this.props.closureRequest;

    requestFn(payload).then((response) => {
      if (response && response.ResponseCode === "200") {
        // Refresh main table after successful closure
        this.props.fetchApi(this.tblResponse);
      }
    });
    
  };

  statusTemplate = (row) => {
    let style = {
      padding: "4px 10px",
      borderRadius: "4px",
      fontWeight: "600",
      display: "inline-block",
    };

    if (row.Status === "Open") {
      style.backgroundColor = "#fff3cd"; // yellow
      style.color = "#856404";
    } else if (row.Status === "Close") {
      style.backgroundColor = "#e3e668fd"; // red
      style.color = "#721c24";
    } else if (row.Status === "Assign") {
      style.backgroundColor = "#67db63fd"; // green
      style.color = "#ffffff";
    } else if (this.isRejectStatus(row.Status)) {
      style.backgroundColor = "#f8d7da"; // light red
      style.color = "#721c24";
    }
    return <span style={style}>{row.Status}</span>;
  };

  render() {
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <div className="col-md-5  ">
          <h4>Comphensive Service</h4>
        </div>

        <div className="col-md-12" style={{ marginTop: "10px" }}>
          <div className="row ">
            {/* From Date */}
            <div className="col-md-2 col-sm-12">
              <Calendar
                placeholder="From Date"
                showIcon
                name="FromDate"
                value={this.state.FromDate}
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
              />
            </div>

            {/* To Date */}
            <div className="col-md-2 col-sm-12">
              <Calendar
                placeholder="To Date"
                showIcon
                name="ToDate"
                value={this.state.ToDate}
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
              />
            </div>

            {/* Open / Close Dropdown */}
            <div className="col-md-2 col-sm-12">
              <Dropdown
                value={this.state.statusFilter}
                options={[
                  { label: "All", value: "All" },
                  { label: "Open", value: "Open" },
                  { label: "Assign", value: "Assign" },
                  { label: "Close", value: "Close" },
                  { label: "Reject", value: "Reject" },
                ]}
                onChange={this.onStatusChange}
                placeholder="Select Status"
                className="w-100"
              />
            </div>

            {/* Submit + Export */}
            <div className="col-md-2 col-sm-12 text-center buttone">
              <button
                type="button"
                onClick={this.FilterData}
                className="btn btn-primary p-2 pl-3 pr-3"
              >
                Submit
              </button>
              &nbsp;&nbsp;&nbsp;
            <button
              className="btn btn-success p-2 pl-3 buttone1"
              onClick={this.handleExport}
            >
              Export
            </button>
            </div>

            {/* Search */}
            <div className="col-md-2 col-sm-12 mt-1">
              <TextField
                id="standard-basic"
                size="small"
                variant="outlined"
                className="fullwidth"
                label="Search"
                onInput={this.searchFilter}
              />
            </div>
          </div>
        </div>
        <Dialog
          header="Closure Request"
          visible={this.state.editVisible}
          style={{ width: "30vw" }}
          modal
          onHide={() => this.setState({ editVisible: false })}
        >
          <div className="p-fluid">
            {/* Status Dropdown */}
            <Dropdown
              style={{ marginTop: "10px" }}
              value={this.state.statusValue}
              options={this.state.statusOptions} // ✅ dynamic
              placeholder="Select Status"
              onChange={(e) => this.setState({ statusValue: e.value })}
              className="w-100 mb-3"
            />

            <Dropdown
              value={this.state.selectedTrade}
              options={this.getTradeOptions()}
              placeholder="Select Trade Name"
              onChange={this.onTradeChange}
              className="w-100 mb-3"
            />

            {/* Agent Dropdown */}
            <Dropdown
              value={this.state.selectedAgent}
              options={(this.state.agentList || []).map((a) => ({
                label: a.ContactPersonName,
                value: a.ContactPersonName,
              }))}
              placeholder="Select Contact Person"
              onChange={this.onAgentChange}
              className="w-100 mb-3"
              disabled={!this.state.selectedTrade}
            />

            <Dropdown
              value={this.state.selectedDistrictObj}
              options={this.state.districtList}
              optionLabel="DistrictName"
              placeholder="Select District"
              onChange={this.onDistrictChange}
              className="w-100 mb-3"
              disabled={!this.state.selectedTrade}
            />
            <TextField
              label="Pin Code"
              variant="outlined"
              className="w-100 mb-3"
              value={this.state.selectedPinCode}
              disabled
            />

            {/* Remarks */}
            <TextField
              label="Remarks"
              variant="outlined"
              className="w-100"
              value={this.state.statusRemarks}
              onChange={(e) => this.setState({ statusRemarks: e.target.value })}
            />

            {/* Submit Button */}
            <button
              className="btn btn-success mt-3"
              onClick={() => this.submitClosureRequest(false)}
              disabled={
                !this.state.statusValue ||
                (!this.isRejectStatus(this.state.statusValue) &&
                  (!this.state.selectedTrade || !this.state.selectedAgent))
              }
            >
              Submit
            </button>
          </div>
        </Dialog>

        <Dialog
          header="Confirm Rejection"
          visible={this.state.confirmRejectVisible}
          style={{ width: "25vw" }}
          modal
          onHide={() => this.setState({ confirmRejectVisible: false })}
        >
          <div>
            <p>Are you sure you want to reject?</p>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-secondary mr-2"
                onClick={() => this.setState({ confirmRejectVisible: false })}
              >
                No
              </button>
              <button
                className="btn btn-danger"
                onClick={() => this.submitClosureRequest(true)}
              >
                Yes
              </button>
            </div>
          </div>
        </Dialog>

        <div className="card" style={{ marginTop: "10px" }}>
          <DataTable
            value={this.props.FeedbackList}
            className="comprehensive-table"
            scrollable
            scrollDirection="horizontal"
             style={{ width: "100% " }}
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="VerificationId"
              disabled
              header="Request Number"
              sortable
            ></Column>
            <Column
              field="ProductName"
              disabled
              header="Product Name "
              sortable
            ></Column>

            <Column field="UserName" disabled header="Name " sortable></Column>
            <Column
              field="MobileNo"
              disabled
              header="Mobile No."
              sortable
            ></Column>
            <Column field="Address" disabled header="Address" sortable body={this.addressBodyTemplate}></Column>
            <Column field="Pincode" disabled header="Pincode" sortable></Column>
            <Column field="state" disabled header="State" sortable></Column>
            <Column
              field="Status"
              disabled
              header="Status"
              body={this.statusTemplate}
              sortable
            ></Column>
            <Column field="Remark" disabled header="Remark" sortable></Column>

            <Column
              field="AssignReqDate"
              header="Assign Request Date"
              sortable
              body={(rowData) => this.formatDate(rowData, "AssignReqDate")}
            />

            <Column
              field="CloseReqDate"
              header="Close Request Date"
              sortable
              body={(rowData) => this.formatDate(rowData, "CloseReqDate")}
            />
            <Column
              field="image"
              header="image"
              body={this.photoBodyTemplate}
            ></Column>
            <Column
              field="warrantyimage"
              header="Warranty image"
              body={this.photoBodyTemplate1}
            ></Column>
            <Column
              field="invoice"
              header="Invoice image"
              body={this.photoBodyTemplate2}
            ></Column>
             <Column field="StatusRemarks" disabled header="Status Remarks" sortable></Column>
            <Column
              field="RemarkUpdatedOn"
              disabled
              header="Service Request Date"
              sortable
            ></Column>
            <Column header="Action" body={this.actionTemplate}></Column>
            <Column header="Rejection" body={this.rejectionTemplate}></Column>
          </DataTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    FeedbackList: state.FeedbackRpt.items,
    ServiceAgentList: state.FeedbackRpt.serviceAgentList || [],
    List:
      state.FeedbackRpt.exportitems == undefined
        ? []
        : state.FeedbackRpt.exportitems,
    loading: state.verification.loding,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(FeedbackRptActions.ServiceReq(obj));
    },
    loadingData: (isLoding) =>
      dispatch(FeedbackRptActions.loadingData(isLoding)),
    exportingData: (obj) => dispatch(FeedbackRptActions.exportServiceReq(obj)),
    closureRequest: (obj) => {
      return dispatch(FeedbackRptActions.ClosureRequest(obj));
    },
    rejectionRequest: (obj) => {
      return dispatch(FeedbackRptActions.RejectionRequest(obj));
    },
    // NEW: fetch trade + agent list for dependent dropdowns
    getServiceAgentList: () =>
      dispatch(FeedbackRptActions.getServiceAgentList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComperihensiveRep);

